<template>
  <navbar
    is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
    btn-background="bg-gradient-danger"
    :dark-mode="true"
  />
  <div
    class="mx-3 page-header bg-gradient-danger position-relative border-radius-xl"
  >
    <section
      class="container-fluid pb-5 pt-7 postion-relative z-index-2"
      id="inicio"
    >
      <div class="row">
        <div class="mx-auto text-center col-md-6">
          <div class="row">

            <div class="col-12 text-white title">
              ViajaBara
            </div>
            <div class="col-12 text-white title">
              y de volada
            </div>
            <div class="col-12 text-white mt-4">
              <div class="row">
                <div class="col-12 col-md-6 text-center text-md-end">
                  <a target="_blank" rel="noopener" role="button" class="btn btn-dark justify-content-center">
                    Descargar <i class="fa fa-apple text-white ms-2" style="font-size: 1.5em;"></i>
                  </a>
                </div>
                <div class="col-12 col-md-6 text-center text-md-start">
                  <a target="_blank" rel="noopener" role="button" class="btn btn-info justify-content-center">
                    Descargar <i class="fa fa-android text-white ms-2" style="font-size: 1.5em;"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mx-auto text-center col-md-6 mx-2 d-none d-lg-block">
          <img
            src="../../../../assets/img/landing-image.png"
            class="img-fluid"
            srcset=""
          />
        </div>
        <div class="col-8 offset-2 mt-4">
          <p class="text-white text-center font-italic">
            Para ViajaBara tu salud es lo más importante, por ello tomamos las
            medidas sanitarias necesarias para brindarte la mayor seguridad en
            tus viajes. Utiliza tu cubrebocas durante el viaje. ¡cuidémonos¡
          </p>
        </div>
      </div>
    </section>
  </div>

  <div class="container my-6">
    <section class="container fadeIn2 fadeInBottom" id="quienes">
      <div class="row">
        <div class="col-12 text-center">
          <h2>¿Quiénes somos?</h2>
          <p class="mt-5">
            ViajaBara SAS de CV es una empresa de transporte comprometida con
            brindarte un servicio de calidad en cada uno de tus viajes.
          </p>
          <p class="mt-3 fw-bold">
            Contamos con el mejor servicio del mercado teniendo vans con confort
            premium, climatizadas y asientos reclinables además de contar con
            una operación 100% regulada, choferes expertos con licencia federal
            para garantizar la seguridad y protección total con nuestro seguro
            de viajero, nuestras vans están listas para todo y siempre limpias
            siguiendo protocolos sanitarios.
          </p>
          <p class="mt-2 fw-bold">¡También gestionamos envíos de paquetería!</p>
          <p class="mt-2">
            ViajaBara es una nueva forma de viajar, ViajaBara te ofrece un
            transporte rápido, cómodo y seguro. ¡Vive la experiencia de viajar
            con ViajaBara¡
          </p>
        </div>
        <div class="col-12 text-center"></div>
      </div>
    </section>

    <hr class="mt-5 mb-2 horizontal dark" />

    <section class="container fadeIn2 fadeInBottom" id="rutas">
      <div class="row">
        <div class="col-12 text-center">
          <h2 class="mb-5">Ruta Actual</h2>
          <div class="row">
            <div class="col-12 text-start ms-5 mb-3">
              <h6 class="text-secondary">Cuernavaca - Puebla</h6>
            </div>
            <div class="col-12">
              <div class="multisteps-form__progress mb-5">
                <button
                  class="multisteps-form__progress-btn js-active"
                  type="button"
                  title="User Info"
                  :class="activeStep >= 0 ? activeClass : ''"
                  @click="activeStep = 0"
                >
                  <span class="d-block">Parque alameda</span>
                  <span class="d-block">Walmart Jiutepec</span>
                  <span class="d-block">Parada UPEMOR</span>
                </button>
                <button
                  class="multisteps-form__progress-btn js-active"
                  type="button"
                  title="Address"
                  :class="activeStep >= 1 ? activeClass : ''"
                  @click="activeStep = 1"
                >
                  <span class="d-block">Cecina Yecapixtla</span>
                </button>
                <button
                  class="multisteps-form__progress-btn js-active"
                  type="button"
                  title="Socials"
                  :class="activeStep >= 2 ? activeClass : ''"
                  @click="activeStep = 2"
                >
                  <span class="d-block">Plaza Aventura</span>
                </button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 text-start ms-5 mb-3">
              <h6 class="text-secondary">Puebla - Cuernavaca</h6>
            </div>
            <div class="col-12">
              <div class="multisteps-form__progress">
                <button
                  class="multisteps-form__progress-btn js-active"
                  type="button"
                  title="User Info"
                  :class="activeStep >= 0 ? activeClass : ''"
                  @click="activeStep = 0"
                >
                  <span class="d-block">Café Yaguar Tlaxcalancingo</span>
                </button>
                <button
                  class="multisteps-form__progress-btn js-active"
                  type="button"
                  title="Address"
                  :class="activeStep >= 1 ? activeClass : ''"
                  @click="activeStep = 1"
                >
                  <span class="d-block">Parada Home Depot Cuautla</span>
                </button>
                <button
                  class="multisteps-form__progress-btn js-active"
                  type="button"
                  title="Socials"
                  :class="activeStep >= 2 ? activeClass : ''"
                  @click="activeStep = 2"
                >
                  <span class="d-block">IMSS Cuernavaca</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <hr class="mt-5 mb-2 horizontal dark" />

    <section class="container fadeIn2 fadeInBottom" id="servicios">
      <div class="row">
        <div class="col-12 text-center"><h2>Servicios adicionales</h2></div>
        <div class="col-12 mt-5 col-md-3">
          <div class="card h-100">
            <div class="py-3 text-center card-header d-flex justify-content-center align-items-between">
              <div class="icon icon-shape icon-lg shadow text-center border-radius-lg bg-gradient-danger">
                <i class="opacity-10 text-white fas fa-bus" aria-hidden="true" style="font-size: 32px"></i>
              </div>
            </div>
            <div class="p-3 pt-0 text-center card-body">
              <h6 class="mb-0 text-center">Transporte Escolar</h6>
            </div>
          </div>
        </div>
        <div class="col-12 mt-5 col-md-3">
          <div class="card h-100">
            <div class="py-3 text-center card-header d-flex justify-content-center">
              <div class="icon icon-shape icon-lg shadow text-center border-radius-lg bg-gradient-danger">
                <i class="opacity-10 text-white fas fa-bus" aria-hidden="true" style="font-size: 32px"></i>
              </div>
            </div>
            <div class="p-3 pt-0 text-center card-body">
              <h6 class="mb-0 text-center">Transporte Turistico</h6>
            </div>
          </div>
        </div>
        <div class="col-12 mt-5 col-md-3">
          <div class="card h-100">
            <div class="py-3 text-center card-header d-flex justify-content-center">
              <div class="icon icon-shape icon-lg shadow text-center border-radius-lg bg-gradient-danger">
                <i class="opacity-10 text-white fas fa-car" aria-hidden="true" style="font-size: 32px"></i>
              </div>
            </div>
            <div class="p-3 pt-0 text-center card-body">
              <h6 class="mb-0 text-center">Transporte para eventos y empresas</h6>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3 mt-5">
          <div class="card h-100">
            <div class="py-3 text-center card-header d-flex justify-content-center">
              <div class="icon icon-shape icon-lg shadow text-center border-radius-lg bg-gradient-danger">
                <i class="opacity-10 text-white fas fa-box" aria-hidden="true" style="font-size: 32px"></i>
              </div>
            </div>
            <div class="p-3 pt-0 text-center card-body">
              <h6 class="mb-0 text-center">Paquetería</h6>
            </div>
          </div>
        </div>
      </div>
    </section>

    <hr class="mt-5 mb-2 horizontal dark" />

    <section class="container fadeIn2 fadeInBottom" id="paqueteria">
      <div class="row">
        <div class="col-12 text-center mb-3"><h2>Paquetería</h2></div>
        <div class="col-12">
          <div class="row">
            <div class="col-12 col-lg-6">
              <img src="../../../../assets/paqueteria.png" class="img-fluid" srcset="" />
            </div>
            <div class="col-12 col-lg-6">
              <h6 class="text-center mb-4">Servicio especializado en envío de paquetes y transporte de mercancías</h6>
              <p class="justified">Viajabara se convierte en un excelente socio estratégico para transportar lo que requieras. Desde un servicio de paquetería a soluciones especializadas en movilidad de carga consolidada, dedicada, fría, seca, hidrocarburos, etc. Te invitamos a conocernos.</p>
              <p class="justified">Conoce los diferentes servicios de transporte de mercancías que Viajabara tiene para ti. Viajabara te acerca hasta donde tú quieras: ¡pregunta por nuestras tarifas!</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <footer class="container-fluid bg-gradient-danger" id="contacto">
    <div class="row py-3">
      <div class="col-12 text-center text-white">
        <span class="fw-bold" style="font-size: 1.5em">
          <img :src="bus" class="me-2" alt="" />
          ViajaBara
        </span>
      </div>
      <div class="col-12 text-center text-white">
        <span style="font-family: 'monserrat'; font-size: 1.2em">
          Viaja sencillo, barato y de volada.
        </span>
      </div>
      <div class="col-12 mt-3 text-center">
        <!-- Instagram Link -->
        <a href="https://www.instagram.com/viajabara_mexico?utm_source=qr" target="_blank" rel="noopener" class="text-secondary ms-4 me-4">
          <span class="fab fa-instagram text-white" style="font-size: 2.5em"></span>
        </a>

        <!-- Facebook Link -->
        <a href="https://www.facebook.com/share/1H83zHcv9n/?mibextid=wwXIfr" target="_blank" rel="noopener" class="text-secondary me-4">
          <span class="fab fa-facebook text-white" style="font-size: 2.5em"></span>
        </a>

        <!-- WhatsApp Link -->
        <a href="https://wa.me/527773892248" target="_blank" rel="noopener" class="text-secondary me-4">
          <span class="fab fa-whatsapp text-white" style="font-size: 2.5em"></span>
        </a>
      </div>

      <!-- Enlace que redirige a la ruta de terminos y condiciones -->
      <div class="col-12 mt-3 text-center">
        <router-link
          to="/politica-de-privacidad"
          class="text-white text-decoration-underline"
          style="font-family: 'monserrat'; font-size: 0.9em"
        >
          POLÍTICA DE PRIVACIDAD
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import setNavPills from "@/assets/js/nav-pills.js";
import icon from "../../../../assets/img/landing-image.png";
import bus from "../../../../assets/img/bus-footer.png";
import vanLogo from "@/assets/img/logo-viajabara.png";

export default {
  name: "LandingPage",
  components: {
    Navbar,
  },
  data() {
    return {
      icon,
      bus,
      vanLogo,
      activeStep: 0,
      activeClass: "js-active"
    };
  },
  mounted() {
    this.$store.state.showSidenav = false;
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = false;
    setNavPills();
  },
  beforeUnmount() {
    this.$store.state.showSidenav = true;
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    if (this.$store.state.isPinned === false) {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (sidenav_show) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
      }
      this.$store.state.isPinned = true;
    }
  },
};
</script>

<style scoped>
  .justified {
    text-align: justify;
  }
 .fade-in {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.title {
  font-size: 3rem;
  font-family: 'Parisienne', cursive;
  font-style: italic;
}

@media (min-width: 576px) { 
  .title {
    font-size: 2rem;
  }
}

@media (min-width: 768px) { 
   .title {
    font-size: 2.5rem;
  }
 }

@media (min-width: 992px) { 
   .title {
    font-size: 3rem;
  }
 }

@media (min-width: 1200px) { 
   .title {
    font-size: 5rem;
  }
 }

@media (min-width: 1400px) {
   .title {
    font-size: 5rem;
  }
 }
</style>